import { Component, Input } from '@angular/core';
import { Language } from '../../generic/classes/language';
import { availableLanguagesArray } from './available.languages.array';

@Component({
    selector: '[render-language]',
    template: `{{ displayValue() }}`,
    standalone: true,
})
export class RenderLanguageComponent {
    @Input() language: string;
    @Input() short: boolean;

    languages: Language[];

    constructor() {
        this.languages = availableLanguagesArray;
    }

    public displayValue(): string {
        const matchingLanguage = this.languages.find(
            language => language.shopKey === this.language,
        );

        if (!matchingLanguage) {
            return '';
        }

        return this.short ? matchingLanguage.iso : matchingLanguage.displayName;
    }
}
